// import axios from 'axios'

const axios = require('axios')

axios.defaults.baseURL = process.env.VUE_APP_CJ_API || 'http://localhost:3000/api'
const data = JSON.parse(window.localStorage.getItem('auth.currentUser'))
let token = ''
if (data) {
  token = data.token
}
axios.defaults.headers['Authorization'] = `Bearer ${token}`
module.exports = axios
